// src/utils/crypto.ts
import CryptoJS from 'crypto-js'

// 必须是16/24/32位
const SECRET_KEY = "1234567890123456"

export const encrypt = (text: string): string => {
  return CryptoJS.AES.encrypt(
    text,
    SECRET_KEY,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }
  ).toString()
}

export const decrypt = (ciphertext: string): string => {
  const bytes = CryptoJS.AES.decrypt(
    ciphertext,
    SECRET_KEY,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }
  )
  return bytes.toString(CryptoJS.enc.Utf8)
}
